import React from 'react';
import styled from 'styled-components';

const TypingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: white;
  border-radius: 18px;
  border-bottom-left-radius: 6px;
  max-width: 75%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  
  span {
    width: 8px;
    height: 8px;
    background: #94a3b8;
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;
    
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
  
  @keyframes typing {
    0%, 60%, 100% {
      transform: translateY(0);
      opacity: 0.5;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

const TypingIndicator = () => {
  return (
    <TypingContainer>
      <span></span>
      <span></span>
      <span></span>
    </TypingContainer>
  );
};

export default TypingIndicator; 